import styled from 'styled-components'
import { Button } from '~/components/shared'
import { message } from '~/services'

export const Card = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 2rem;
  max-width: 620px;

  border-top: 0.5rem solid ${props => props.theme.colors.color122d52};
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  z-index: 10000;
`

export const Title = styled.h3`
  margin-bottom: 2rem;

  color: ${props => props.theme.colors.color122d52};
  font-family: 'Inter';
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Description = styled.p`
  color: ${props => props.theme.colors.color122d52};
  font-family: 'Inter';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`

export const SubmitDisclaimer = styled.p`
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`

export const ButtonsContainer = styled.div`
  position: relative;
  flex: 1;

  display: flex;
  justify-content: center;
  gap: 1rem;
`

export const ReturnButton = styled(Button).attrs(props => ({
  ...props,
  minWidth: 'large',
  variant: 'outlined',
  children: message('feedback.ask_later_label')
}))`
  text-transform: uppercase;
  height: 2rem;
`

export const SubmitButton = styled(Button).attrs(props => ({
  ...props,
  type: 'submit',
  minWidth: 'large',
  children: message('feedback.submit_label'),
  ['data-testid']: 'submit-button'
}))`
  height: 2rem;
`
